<template>
  <el-table-column
    prop="suppliers"
    label="Beszállítók"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      <el-tooltip v-if="scope.row.suppliers.length" placement="top" style="max-width: 150px;" popper-class="permission-info-tooltip">
        <div slot="content">
          {{ scope.row.suppliers.map(s => s.company.name).join(', ') }}
        </div>
        <el-tag v-if="scope.row.suppliers.length" type="primary">{{ scope.row.suppliers.length }} beszállító</el-tag>
      </el-tooltip>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'suppliers',
  };
</script>
